import { LazyQueryHookOptions, useLazyQuery } from '@apollo/client'
import buyAgainQuery from './query'
import { IBuyAgainVariables, IBuyAgainResponse } from './types'

/**
 * Hook declaration to obtain a lazy query of buy again products.
 * @param options: LazyQueryHookOptions without the fetch-policy keys
 * @internal
 */
const useLazyBuyAgain = (
  options?: Omit<
    LazyQueryHookOptions<IBuyAgainResponse, IBuyAgainVariables>,
    'fetchPolicy' | 'nextFetchPolicy' | 'initialFetchPolicy'
  >,
) => {
  return useLazyQuery<IBuyAgainResponse, IBuyAgainVariables>(buyAgainQuery, {
    ...options,
    fetchPolicy: 'no-cache',
    // Neutralised beside the pin, not merely omitted from the type: both
    // survive the spread otherwise, and `nextFetchPolicy` would take over
    // from the second fetch onward.
    nextFetchPolicy: undefined,
    initialFetchPolicy: undefined,
  })
}

export { useLazyBuyAgain }
